import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    ...shorthands.padding(0, tokens.spacingHorizontalL),
  },
  previewButton: {
    marginLeft: tokens.spacingHorizontalL,
    whiteSpace: 'nowrap',
  },
  saveButton: {
    marginLeft: tokens.spacingHorizontalL,
    whiteSpace: 'nowrap',
  },
  aspectRatio: {
    display: 'flex',
    marginLeft: tokens.spacingHorizontalL,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  divider: {
    marginLeft: tokens.spacingHorizontalL,
  },
});
